<mat-expansion-panel
  [expanded]="input.expanded | parse: context | async"
  [disabled]="input.disabled | parse: context | async"
>
  <mat-expansion-panel-header
    [collapsedHeight]="input.panelHeaderHeight | parse: context | async"
    [expandedHeight]="input.panelContentHeight | parse: context | async"
  >
    <mat-panel-title>
      <ng-container [dynamicWidget]="input.title" [context]="context" />
    </mat-panel-title>
    @if (input.description) {
      <mat-panel-description>
        <ng-container [dynamicWidget]="input.description" [context]="context" />
      </mat-panel-description>
    }
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div
      [ngStyle]="{
        backgroundColor: input.panelBackgroudColor | parse: context | async,
      }"
    >
      @for (widget of input.widgets; track widget) {
        <ng-container
          [dynamicWidget]="widget"
          [context]="context"
        ></ng-container>
      }
    </div>
  </ng-template>
  @if (input.actions) {
    <mat-action-row>
      @for (action of input.actions; track action) {
        <ng-container [dynamicWidget]="action" [context]="context" />
      }
    </mat-action-row>
  }
</mat-expansion-panel>
